import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class DesiccantAirDryerNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.DesiccantAirDryer,
    });
  }
}
